module.exports = __webpack_public_path__ + "assets/img/cut4.f417ce78.png";